import React, { useState } from 'react';
import { Sidebar } from './ui';
import PublicMainContent from './PublicMainContent';


const PublicDiscoverPage: React.FC = () => {
    const [selectedCategory, setSelectedCategory] = useState<string>('All');
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const handleCategorySelect = (category: string) => {
        setSelectedCategory(category);
        // Close mobile menu after selection
        setIsMobileMenuOpen(false);
    };

    return (
        <div className="flex flex-col w-full min-h-screen">
            <div className="flex flex-1 px-4 gap-8">

                <div className="hidden lg:block lg:w-1/5">
                    <Sidebar
                        isLoggedIn={false}
                        collections={[]}
                        selectedCollectionId={null}
                        onSelectCollection={() => { }}
                        onShowCreateCollectionModal={() => { }}
                        selectedCategory={selectedCategory}
                        onSelectCategory={handleCategorySelect}
                        isOpen={true}
                        onClose={() => { }}
                        publicMode={true}
                    />
                </div>


                {isMobileMenuOpen && (
                    <Sidebar
                        isLoggedIn={false}
                        collections={[]}
                        selectedCollectionId={null}
                        onSelectCollection={() => { }}
                        onShowCreateCollectionModal={() => { }}
                        selectedCategory={selectedCategory}
                        onSelectCategory={handleCategorySelect}
                        isOpen={isMobileMenuOpen}
                        onClose={() => setIsMobileMenuOpen(false)}
                        publicMode={true}
                    />
                )}

                <div className="flex-1 flex flex-col">
                    <div className='flex-1'>
                        <PublicMainContent
                            selectedCategory={selectedCategory}
                            onCategoriesClick={() => setIsMobileMenuOpen(true)}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PublicDiscoverPage;
